import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton } from '@material-ui/core';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PersonIcon from '@material-ui/icons/Person';
import { Menu, ExitToApp } from '@material-ui/icons';

export default function Header(props) {

    const role = window.localStorage.getItem('role');
    // const theme = useTheme();

    const { classes, variant, open, onClose, onOpen, onSidebarOpen } = props;

    const drawer = (

        <div>
            <div className={classes.toolbar} >

            </div>
            {/* <div className={classes.toolbar} >
                <img style={{

                }} src="https://www.cdlhomes.com.sg/themes/custom/cdl/assets/images/logo.svg"></img>
            </div>
            {open ?
                <div
                    onClick={(e)=>{
                        onClose();
                    }}
                    style={{
                        width: "22",
                        margin: "20px 0 0 19px"
                    }}>
                    <div
                        style={{
                            display: 'block',
                            width: 22,
                            height: 2,
                            background: "url('https://www.cdlhomes.com.sg/themes/custom/cdl/assets/images/line.svg') no-repeat",
                            margin: '5px 0 0 0',
                            transition: 'transform 0.3s linear, margin 0.2s linear'
                        }}
                    ></div>
                    <div
                        style={{
                            display: 'block',
                            width: 22,
                            height: 2,
                            background: "url('https://www.cdlhomes.com.sg/themes/custom/cdl/assets/images/line.svg') no-repeat",
                            margin: '5px 0 0 0',
                            transition: 'transform 0.3s linear, margin 0.2s linear'
                        }}
                    ></div>
                    <div
                        style={{
                            display: 'block',
                            width: 22,
                            height: 2,
                            background: "url('https://www.cdlhomes.com.sg/themes/custom/cdl/assets/images/line.svg') no-repeat",
                            margin: '5px 0 0 0',
                            transition: 'transform 0.3s linear, margin 0.2s linear'
                        }}
                    ></div>
                </div>
                : ''} */}
            {role == 'showroom_operator' ?
                <React.Fragment>
                    <List>
                        <Link to="/appointment" className={classes.link}>
                            <ListItem button >
                                <ListItemIcon><DashboardIcon /></ListItemIcon>
                                <ListItemText primary={"Appointments"} />
                            </ListItem>
                        </Link>

                    </List>
                    <List>
                        <Link to="/showroom" className={classes.link}>
                            <ListItem button >
                                <ListItemIcon><HomeWorkIcon /></ListItemIcon>
                                <ListItemText primary={"Showrooms"} />
                            </ListItem>
                        </Link>
                    </List>
                </React.Fragment>


                : ''}
            {
                role == "superadmin" ?
                    <React.Fragment>
                        <List>
                            <Link to="/appointment" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary={"Appointments"} />
                                </ListItem>
                            </Link>

                        </List>

                        <List>
                            <Link to="/admin" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><PersonIcon /></ListItemIcon>
                                    <ListItemText primary={"Users"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/agency" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><PermContactCalendarIcon /></ListItemIcon>
                                    <ListItemText primary={"Agencies"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/operator" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
                                    <ListItemText primary={"Operators"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/showroom" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><HomeWorkIcon /></ListItemIcon>
                                    <ListItemText primary={"Showrooms"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <ListItem button >
                                <ListItemIcon><AssessmentIcon /></ListItemIcon>
                                <ListItemText primary={"Reports"} />
                            </ListItem>
                            <ListItem button >
                                <List>
                                    {/* <Link to="/barchart" className={classes.link}>
                                        <ListItem button >
                                            <ListItemIcon><MeetingRoomIcon /></ListItemIcon>
                                            <ListItemText primary={"Overview"} />
                                        </ListItem>
                                    </Link> */}
                                    <Link to="/property_overview" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property Overview"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/agency_overview" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency Overview"} />
                                        </ListItem>
                                    </Link>

                                    <Link to="/report_time_property" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property Over Time"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/report_time_agency" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency Over Time"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/property_by_agency" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property by Agency"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/agency_by_property" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency by Property"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/report_property" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/report_agency" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/agency_guest" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency Guest"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/property_guest" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property Guest"} />
                                        </ListItem>
                                    </Link>
                                </List>
                            </ListItem>
                        </List>
                    </React.Fragment>

                    : ''
            }

            {
                role == "admin" ?
                    <React.Fragment>
                        <List>
                            <Link to="/admin" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><PersonIcon /></ListItemIcon>
                                    <ListItemText primary={"Users"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/appointment" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary={"Appointments"} />
                                </ListItem>
                            </Link>

                        </List>
                        <List>
                            <Link to="/agency" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><PermContactCalendarIcon /></ListItemIcon>
                                    <ListItemText primary={"Agencies"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/operator" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
                                    <ListItemText primary={"Operators"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/showroom" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><HomeWorkIcon /></ListItemIcon>
                                    <ListItemText primary={"Showrooms"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <ListItem button >
                                <ListItemIcon><AssessmentIcon /></ListItemIcon>
                                <ListItemText primary={"Reports"} />
                            </ListItem>
                            <ListItem button >
                                <List>
                                    {/* <Link to="/barchart" className={classes.link}>
                                        <ListItem button >
                                            <ListItemIcon><MeetingRoomIcon /></ListItemIcon>
                                            <ListItemText primary={"Overview"} />
                                        </ListItem>
                                    </Link> */}
                                    <Link to="/property_overview" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property Overview"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/agency_overview" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency Overview"} />
                                        </ListItem>
                                    </Link>

                                    <Link to="/report_time_property" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property Over Time"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/report_time_agency" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency Over Time"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/property_by_agency" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property by Agency"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/agency_by_property" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency by Property"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/report_property" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Property"} />
                                        </ListItem>
                                    </Link>
                                    <Link to="/report_agency" className={classes.link}>
                                        <ListItem button >
                                            <ListItemText primary={"Agency"} />
                                        </ListItem>
                                    </Link>

                                </List>
                            </ListItem>
                        </List>
                    </React.Fragment>

                    : ''
            }

            {
                role == 'agency' ?
                    <React.Fragment>
                        <List>
                            <Link to="/dashboard_agency" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary={"Appointments"} />
                                </ListItem>
                            </Link>
                        </List>
                        <List>
                            <Link to="/agency_admins" className={classes.link}>
                                <ListItem button >
                                    <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
                                    <ListItemText primary={"Admins"} />
                                </ListItem>
                            </Link>
                        </List>

                    </React.Fragment>
                    : ''
            }
            {/* <List>
                <Link to="/appointment" className={classes.link}>
                    <ListItem button >
                        <ListItemIcon><CalendarTodayIcon /></ListItemIcon>
                        <ListItemText primary={"Appointments"} />
                    </ListItem>
                </Link>
            </List> */}


        </div >

    );

    return (
        <Drawer
            anchor="left"
            classes={{ paper: classes.drawerPaper }}
            onClose={onClose}
            onOpen={onOpen}
            open={open}
            variant={variant}
        >
            {drawer}
        </Drawer>

    )
}